import { LoadablePaint } from '@confluence/loadable';

export const RecentlyUpdatedMacroHandler = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RecentlyUpdatedMacro" */ '../src/RecentlyUpdatedMacroRenderer.tsx'
			)
		).RecentlyUpdatedMacroRendererHandler,
});
